import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

// Configurar la ruta base para los iconos de Ionicons ANTES de que se inicie la aplicación
(window as any).Ionicons = {
  config: {
    resourcesUrl: 'https://unpkg.com/ionicons@7.1.0/dist/ionicons/',
  },
};

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));

defineCustomElements(window);
